module.exports = __webpack_public_path__ + "img/logo_2025_web.ceb2d69d.png";